import styled from 'styled-components';
import Button from '@mui/material/Button';

export const OAuthSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 16px 0;
`;
OAuthSection.displayName = 'OAuthSection';

export const OAuthButton = styled(Button)`
  && {
    height: 56px;
    text-transform: none;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 12px;
    border: 1px solid #e0e0e0;
    color: #333;
    background-color: white;
    &:hover {
      background-color: #f5f5f5;
    }
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
`;
OAuthButton.displayName = 'OAuthButton';

export const Divider = styled.div`
  display: flex;
  align-items: center;
  margin: 20px 0;
  color: #666;
  font-size: 14px;
  
  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #e0e0e0;
  }
  
  &::before {
    margin-right: 16px;
  }
  
  &::after {
    margin-left: 16px;
  }
`;
Divider.displayName = 'Divider';